export const getFetchInvoicesPath = (page = 1) => `/profile/invoices.json?page=${page}`;
export const getInvoicesPaymentPath = invoiceId => `/api/v1/invoices/${invoiceId}/payments.json`;
export const accountsBalancesPath = '/wallet/accounts_balances';
export const getInvoiceByIdPath = invoiceId => `/invoices/${invoiceId}.json`;
export const createInvoicePath = '/api/v2/invoices.json';
export const getTariffsPath = '/api/v2/invoices/tariffs';
export const getInvoicesByScopesPath = scope => `/api/v2/invoices?scope=${scope}`;
export const balanceReplenishmentPath = '/api/v2/profile/payments.json';
